import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useOnboardWriter } from "@/hooks/useWriter";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";
import { Card } from "@/components/ui/Card";
import { PenLine } from "lucide-react";

export function OnboardPage() {
  const navigate = useNavigate();
  const onboardMutation = useOnboardWriter();
  const [displayName, setDisplayName] = useState("");
  const [bio, setBio] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onboardMutation.mutate(
      { displayName, bio },
      { onSuccess: () => navigate("/writer/dashboard") },
    );
  };

  return (
    <div className="max-w-sm mx-auto px-4 py-20">
      <div className="text-center mb-8">
        <div className="flex justify-center mb-4">
          <div className="p-3 rounded-full bg-orange/10">
            <PenLine className="text-orange" size={24} />
          </div>
        </div>
        <h1 className="text-2xl font-display font-bold mb-2">
          Set Up Your Profile
        </h1>
        <p className="text-grey font-body text-sm">
          Create your writer profile and we'll provision a wallet for you.
        </p>
      </div>

      <Card className="p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            label="Display Name"
            value={displayName}
            onChange={(e) => setDisplayName(e.target.value)}
            placeholder="Your pen name"
            required
          />
          <div className="flex flex-col gap-1">
            <label className="text-sm font-body font-bold text-grey">
              Bio
            </label>
            <textarea
              value={bio}
              onChange={(e) => setBio(e.target.value)}
              placeholder="Tell readers about yourself... (optional)"
              rows={3}
              className="px-3 py-2 rounded-lg border border-beige/40 bg-white font-body text-sm focus:outline-none focus:ring-2 focus:ring-orange/50 focus:border-orange placeholder:text-beige resize-y"
            />
          </div>
          <Button
            type="submit"
            className="w-full"
            loading={onboardMutation.isPending}
          >
            Create Profile
          </Button>
          {onboardMutation.isError && (
            <p className="text-sm text-red-600 font-body text-center">
              Failed to create profile. Please try again.
            </p>
          )}
        </form>
      </Card>
    </div>
  );
}
